<template>
<b-container fluid>
  <div>
      <h1>Vehículos</h1>
        <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar vehículo"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Registros por página" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getVehicles"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(acciones)="row" v-if="this.$store.state.user.role != 'AUTORIDADES - STCH'">
        <!--<router-link size="sm" :to="{name:'postVehicles', params:{id:row.item.id}}" class="mr-1"><b-button v-if="row.item.id" class="btn-sm" variant="outline-warning">Editar</b-button></router-link>-->
        <b-button v-if="row.item.id" @click="validateCheckIn(row.item)" class="btn-sm" variant="outline-warning">Editar</b-button>
        <b-button class="btn-sm" variant="outline-info" @click="showUnlinkVehicle(row.item)" title="Liberar vehículo"><i class="fa-solid fa-link-slash"></i></b-button>
        <!--<b-button class="btn-sm" v-if="row.item.active" variant="outline-danger" v-b-modal.modal-prevent-closing @click="getIdRow({id:row.item.id})">Deshabilitar</b-button>-->
        <!--<b-button v-if="row.item.taximeter"  class="btn-sm" variant="outline-danger" @click="unlinkTaximeter(row.item.id)">Desvincular de taxímetro</b-button>-->
      </template>
      <!--<template v-slot:cell(Concesion)="row">
       {{ getAllConcecionesNumbers[row.item.id] }}
      </template>-->
      <template v-slot:cell(qr)="row" v-if="this.$store.state.user.role != 'AUTORIDADES - STCH'">
        <b-button v-if="row.item.licensePlate" @click="showQR(row.item.licensePlate)" class="btn-sm" variant="outline-secondary">Descargar</b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    </div>
    <!--Modal para ingresar el motivo de baja de un vehículo-->
    <div>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Ingrese motivo"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :state="reasonState"
          label="Motivo"
          label-for="reason-input"
          invalid-feedback="El motivo es requerido"
        >
          <b-form-input
            id="reason-input"
            v-model="reason"
            :state="reasonState"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
        label="Adjuntar evidencia"
        :state="fileState"
        invalid-feedback="Adjuntar motivo es requerido"
        >
                <b-form-file
                v-model="selectedFile"
                :state="fileState"
                placeholder="Adjuntar evidencia"
                drop-placeholder="Drop file here..."
                browse-text="Adjuntar"
                @change="onFileSelected"
                required
                accept="application/pdf,image/x-png,image/gif,image/jpeg"
                ></b-form-file>
        </b-form-group>
      </form>
    </b-modal>
    <!-- modal qr -->
    <b-modal
      no-close-on-backdrop
      centered
      v-model="showQrModal"
      title="QR de Vehículo"
      header-bg-variant="dark"
      header-text-variant="light"
      body-bg-variant="light"
      footer-bg-variant="light"
    >
      <b-container fluid>
        <center>
        <p>{{qrValue}}</p>
        <div ref="printMe" style="margin-top: 3px; width: 206px; height: 206px;">
        <div style="height: 3px;"></div>
        <qrcode-vue
          :value=qrValue
          level='H'
          :size=width >
          </qrcode-vue>
          </div>
          </center>
      </b-container>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="md"
            class="float-right"
            @click="showQrModal=false"
          >
             <p id="ready">
            Listo</p>
          </b-button>
           <b-button
            :disabled = loading
            variant="dark"
            size="md"
            class="float-left"
            @click="saveImage"
          >
          <div class="row">
              <p id="download">
            Descargar</p>
            <span style="margin-right: 2px;" v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          </div>
        </b-button>
        </div>
      </template>
    </b-modal>
     <!-- modal qr -->
  </div>
  <div class="text-center" v-if="$apollo.queries.getVehicles.loading">
    <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
  </div>
</b-container>
</template>
<script>
import gql from 'graphql-tag'
import { uploadFileS3 } from '../../../s3/s3Up'
// import { encrypt } from '@/config/headers'
import QrcodeVue from 'qrcode.vue'
import { Modal } from 'ant-design-vue'
import config from '../../../../environment.json'
import headers from '@/config/headers.js'
const UNLINK_TAXIMETER = gql`
  mutation unlinkTaximeter($vehicleId: Int) {
    unlinkTaximeter(vehicleId: $vehicleId) {
      id
    }
  }
`
const UPDATE_LINKED_VEHICLE = gql`
  mutation updateLinkedVehicle($licensePlate: String) {
    updateLinkedVehicle(licensePlate: $licensePlate) {
      status
      driverId
      updated_at
      __typename
    }
  }
`
const ACTIVE_TAXI_CHECKIN_BY_LICENSE_QUERY = gql`
  query getActiveTaxiCheckInByLicensePlate($licensePlate: String) {
    getActiveTaxiCheckInByLicensePlate(licensePlate: $licensePlate){
      id
      date
      checkInTime
      checkOutTime
      status
      concesion{
        id
        concesionNumber
        active
      }
      driver{
        id
        firstName
        lastName
      }
    }
  }
`
const GET_ALL_CONCESIONES = gql`
query getAllConceciones{
  getAllConceciones{
    id
    concesionNumber
    vehicle{
      id
    }
  }
}
`
export default {
  name: 'Franchises',
  components: {
    QrcodeVue,
  },
  data() {
    return {
      getVehicles: [{}],
      fields: [
        { key: 'brand', label: 'Marca', sortable: true, sortDirection: 'desc' },
        { key: 'model', label: 'Modelo' },
        { key: 'year', label: 'Año' },
        { key: 'licensePlate', label: 'Número de Placa' },
        // { key: 'vehicleType.chargeDiscount', label: 'Descuento' },
        // { key: 'vehicleType.fare', label: 'Tarifa' },
        // { key: 'vehicleType.active', label: 'Estatus' },
        // { key: 'taximeter.serialNumber', label: 'Número de Serie del Taxímetro' },
        // { key: 'taximeter.status', label: 'Estatus del Taxímetro' },
        { key: 'concesion', label: 'Número de Concesión' },
        { key: 'qr', label: 'QR' },
        { key: 'acciones', label: 'Acciones' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      id: 0,
      fileUploaded: null,
      reasonState: null,
      fileState: null,
      reason: null,
      filePath: null,
      selectedFile: null,
      objectFile: [],
      fileExtension: null,
      showQrModal: false,
      qrValue: '',
      width: 200,
      loading: false,
      getAllConcecionesNumbers: {},
    }
  },
  /*
  con taximetro
  apollo: {
    getVehicles: {
      query: gql`query {
      getVehicles{
        id
        brand
        licensePlate
        model
        serialNumber
        subBrand
        year
        active
        vehicleType{
          id
          chargeDiscount
          fare
          active
        }
        taximeter{
          id
          serialNumber
          status
        }
      }
     }`,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getVehicles) {
          this.totalRows = data.getVehicles.length
        }
      },
    },
  },
  */
  apollo: {
    getAllConceciones: {
      query: GET_ALL_CONCESIONES,
      context: headers(),
      result({ data }) {
        data.getAllConceciones.forEach(concesion => {
          if (concesion.vehicle !== null) {
            this.getAllConcecionesNumbers[concesion.vehicle.id] = concesion.concesionNumber
          }
        })
      },
      error(error) {
        console.log(error)
      },
    },
    getVehicles: {
      query: gql`query getVehicles{
      getVehicles{
        id
        brand
        licensePlate
        model
        serialNumber
        subBrand
        year
        active
        vehicleType{
          id
          chargeDiscount
          fare
          active
        } 
      }
     }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getVehicles) {
          this.getVehicles.forEach(vehicle => {
            vehicle.concesion = this.getAllConcecionesNumbers[vehicle.id]
          })
          this.totalRows = data.getVehicles.length
        }
      },
    },
  },
  methods: {
    validateCheckIn(vehicle) {
      this.$apollo.query({ query: ACTIVE_TAXI_CHECKIN_BY_LICENSE_QUERY, variables: { licensePlate: vehicle.licensePlate }, context: headers() })
        .then(({ data }) => {
          if (data.getActiveTaxiCheckInByLicensePlate === null) {
            this.$router.push({ name: 'postVehicles', params: { id: vehicle.id } })
          } else {
            this.showConfirm(vehicle)
          }
        })
        .catch(error => {
          console.log(error)
          this.showConfirm(vehicle)
        })
    },
    showConfirm(vehicle) {
      Modal.info({
        title: `En este momento no se pueden editar los atributos del vehículo  ${vehicle.brand} ${vehicle.model} con placas ${vehicle.licensePlate}, debido a que el conductor al que esta vinculado tiene un check in activo`,
        okText: 'Aceptar',
        cancelText: 'No',
        onOk() {},
      })
    },
    unlinkTaximeter(id) {
      console.log(id)
      this.$apollo.mutate({
        mutation: UNLINK_TAXIMETER,
        context: headers(),
        variables: {
          vehicleId: id,
        },
      })
        .then(result => {
          console.log(result)
          this.$apollo.queries.getVehicles.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    showUnlinkVehicle(vehicle) {
      Modal.confirm({
        title: `Está acción liberará el vehículo ${vehicle.licensePlate} ¿Estás seguro que deseas continuar?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.updateLinkVehicle(vehicle)
        },
      })
    },
    updateLinkVehicle(vehicle) {
      console.log('vehicle')
      console.log(vehicle)
      this.$apollo.query({ query: ACTIVE_TAXI_CHECKIN_BY_LICENSE_QUERY, variables: { licensePlate: vehicle.licensePlate }, context: headers() })
        .then(({ data }) => {
          if (data.getActiveTaxiCheckInByLicensePlate === null) {
            this.$apollo.mutate({ mutation: UPDATE_LINKED_VEHICLE, variables: { licensePlate: vehicle.licensePlate }, context: headers() })
              .then(result => {
                console.log(result)
                this.$apollo.queries.getVehicles.refetch()
              })
              .catch(error => {
                console.log(error)
                this.showConfirm(vehicle)
              })
          } else {
            this.showConfirm(vehicle)
          }
        })
        .catch(error => {
          console.log(error)
          this.showConfirm(vehicle)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFileSelected(event) {
      this.fileUploaded = event.target.files[0]
      this.fileExtension = this.fileUploaded.name.split('.').pop()
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.reasonState = valid
      this.fileState = valid
      return valid
    },
    resetModal() {
      this.reason = ''
      this.reasonState = null
      this.selectedFile = null
      this.fileState = null
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    getIdRow(id) {
      this.idDelete = id.id
    },
    async handleSubmit() {
      if (!this.checkFormValidity()) {
        return
      }
      this.objectFile.fileExtension = this.fileExtension
      this.objectFile.fileUploaded = this.fileUploaded
      const data = await uploadFileS3(this.objectFile)
      this.filePath = data.Location
      /*
        .then(data => {
          this.filePath = data.Location
        })
        .catch(err => {
          console.log(err)
        })
      */
      await this.$apollo.mutate({
        mutation: gql`mutation disableVehicle($idDelete: Int){
          disableVehicle(id:$idDelete) {
            id
          }
        }`,
        context: headers(),
        variables: {
          idDelete: parseInt(this.idDelete),
        },
      })
        .then(res => {
          this.$apollo.queries.getVehicles.refetch()
          this.addEvidence()
        })
        .catch(erro => {
          console.log(erro)
        })

      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    async addEvidence() {
      await this.$apollo.mutate({
        mutation: gql`mutation createVehicleBan($vehicleId:Int, $fileUrl:String, $reason:String, $createdBy:String){
          createVehicleBan(banvehicle:{
            vehicleId:$vehicleId
            fileUrl:$fileUrl
            reason:$reason
            createdBy:$createdBy
          }){
            id
          }
        }`,
        context: headers(),
        variables: {
          vehicleId: parseInt(this.idDelete),
          fileUrl: this.filePath,
          reason: this.reason,
          createdBy: '',
        },
      })
        .then(res => {
        })
        .catch(err => {
          console.log(err)
        })
    },
    showQR(licensePlate) {
      this.showQrModal = true
      this.qrValue = config[process.env.NODE_ENV].qrVehicle + licensePlate
    },
    async saveImage() {
      this.loading = true
      const el = this.$refs.printMe
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: 'dataURL',
      }
      this.output = await this.$html2canvas(el, options)
      // console.log(this.output)
      this.saveAs(this.output, this.qrValue.replace(config[process.env.NODE_ENV].qrVehicle, '') + '.png')
    },
    saveAs(uri, filename) {
      var link = document.createElement('a')
      if (typeof link.download === 'string') {
        link.href = uri
        link.download = filename

        // Firefox requires the link to be in the body
        document.body.appendChild(link)

        // simulate click
        link.click()

        // remove the link when done
        document.body.removeChild(link)
        this.loading = false
      } else {
        window.open(uri)
      }
    },
  },
}
</script>
<style>
.btn.btn-secondary, .show > .btn.btn-secondary {
    background-color: #ACADCB;
    border-color: #ACADCB;
}
.btn.btn-dark, .show > .btn.btn-dark {
    background-color: #042E41;
    border-color: #042E41;
}
.bg-dark {
    background-color: #ACADCB !important;
}

.modal .modal-header .close {
    background: #ACADCB;
}
.modal-title {
    color: #ffffff;
}
#download {
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 0px;
}
#ready {
    margin-left: 35px;
    margin-right: 35px;
    margin-bottom: 0px;
}
.bg-light {
    background-color: #ffffff !important;
}
.btn.btn-outline-secondary, .show > .btn.btn-outline-secondary {
    border-color: #3B4DE6;
    color: #3B4DE6;
}
.btn.btn-outline-secondary:hover, .btn.btn-outline-secondary:active, .show > .btn.btn-outline-secondary:hover, .show > .btn.btn-outline-secondary:active {
    background-color: #3B4DE6 !important;
    border-color: #3B4DE6;
    color: #fff;
}
</style>
